import stickyNav from './stickyNav';
import refreshElemSrc from './refreshElemSrc';
import news from './news';

stickyNav({
    navElemSelector: '.wrapper > nav',
    headerElemSelector: '.wrapper > header',
    stickyClass: 'sticky'
});  

refreshElemSrc({
    elemSelector: 'img, video', 
    attrSelectror: 'data-refresh'
});

window.load_news = news
